// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"114":"a33afc92","424":"37f2f53b","453":"ac6ca85b","676":"08e08a80","679":"455dca4c","843":"bf7d55df","975":"72ab0321"}[chunkId] + ".chunk.js";
};